import { lazyShowFullCompose, lazyShowQuickCompose } from 'owa-calendar-compose-form-store';
import {
    NEW_BUTTON_ANCHOR,
    NEW_BUTTON_RIBBON_ANCHOR,
} from 'owa-calendar-meeting-forms-common-store/lib/helpers/newButtonConstants';
import {
    ComposeFormType,
    FULL_COMPOSE_FORM_TYPE,
    QUICK_COMPOSE_FORM_TYPE,
    FullComposeFormViewType,
} from 'owa-calendar-helpers-types/lib/ComposeTypes';
import { getUndoEntrySource } from '../utils/getUndoEntrySource';
import {
    CalendarNotificationBarCallbackReason,
    NotificationBarCallbackReason,
} from 'owa-calendar-notification-bar';
import {
    resetComposeStore,
    updateIsUndoNotificationShown,
} from 'owa-calendar-compose-form-actions';
import {
    QuickComposeEntrySourceType,
    FullComposeEntrySourceType,
    QUICK_COMPOSE_ENTRY_SOURCE_SURFACE,
} from 'owa-calendar-helpers-types/lib/ComposeMetricTypes';

export default function handleUndoNotificationCallback(
    callbackReason: CalendarNotificationBarCallbackReason,
    composeFormType: ComposeFormType,
    entrySource: QuickComposeEntrySourceType | FullComposeEntrySourceType,
    formId: string,
    surfaceAnchor?: HTMLDivElement | string
) {
    if (callbackReason === NotificationBarCallbackReason.PrimaryActionClicked) {
        updateIsUndoNotificationShown(formId, false);
        let anchor;
        switch (composeFormType) {
            case QUICK_COMPOSE_FORM_TYPE:
                // check if the surface anchor is valid, and if not, try anchoring to the new event button
                if (
                    surfaceAnchor instanceof HTMLDivElement &&
                    document.body.contains(surfaceAnchor)
                ) {
                    anchor = surfaceAnchor;
                } else if (
                    typeof surfaceAnchor === 'string' &&
                    document.querySelector(surfaceAnchor)
                ) {
                    anchor = surfaceAnchor;
                } else if (entrySource == QUICK_COMPOSE_ENTRY_SOURCE_SURFACE) {
                    if (document.querySelector(NEW_BUTTON_RIBBON_ANCHOR)) {
                        anchor = NEW_BUTTON_RIBBON_ANCHOR;
                    } else {
                        anchor = NEW_BUTTON_ANCHOR;
                    }
                }
                lazyShowQuickCompose.importAndExecute(
                    formId,
                    anchor,
                    getUndoEntrySource(
                        entrySource,
                        QUICK_COMPOSE_FORM_TYPE
                    ) as QuickComposeEntrySourceType
                );
                break;
            case FULL_COMPOSE_FORM_TYPE:
                // TODO: Update Undo handler for projection
                // https://outlookweb.visualstudio.com/Outlook%20Web/_workitems/edit/124540
                lazyShowFullCompose.importAndExecute(
                    false /* isCharmExplicitlySet */,
                    getUndoEntrySource(
                        entrySource,
                        FULL_COMPOSE_FORM_TYPE
                    ) as FullComposeEntrySourceType,
                    FullComposeFormViewType.Modal,
                    undefined /* shouldOpenSchedulingAssistant */,
                    undefined /* extractionSourceId */,
                    undefined /* internetMessageId */,
                    undefined /* createCollabSpaceOnInitProps */,
                    formId
                );
        }
    } else {
        resetComposeStore(formId);
    }
}
